import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dddef9ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  id: "description",
  class: "text"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { id: "stack" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "project-list",
      class: _normalizeClass({ light: !_ctx.darkMode })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectList, (project, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["project text", { selected: project.shortName === _ctx.selectedProject }]),
          key: index,
          onClick: ($event: any) => (_ctx.selectProject(project.shortName))
        }, _toDisplayString(_ctx.shouldShowShortName ? project.shortName : project.name), 11, _hoisted_1))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      id: "project-container",
      ref: "resizeElement",
      class: _normalizeClass({
      light: !_ctx.darkMode,
      hasScrollBar: _ctx.hasScrollBar,
    })
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["title", { light: !_ctx.darkMode }])
      }, _toDisplayString(_ctx.getSelectedProject?.name), 3),
      _createElementVNode("img", {
        id: "screen",
        src: _ctx.getSelectedProject?.imgPath,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.getSelectedProject?.link || null)))
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("project." + _ctx.getSelectedProject?.tradsKey + "1")), 1),
      _createElementVNode("div", {
        id: "more-description",
        class: _normalizeClass(["text", { extended: _ctx.isExpanded }]),
        innerHTML: _ctx.$t('project.' + _ctx.getSelectedProject?.tradsKey + '2')
      }, null, 10, _hoisted_4),
      _createElementVNode("div", {
        id: "see-more",
        class: "text",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleText && _ctx.toggleText(...args)))
      }, _toDisplayString(_ctx.isExpanded ? _ctx.$t("SL") : _ctx.$t("SM")), 1),
      _createElementVNode("div", _hoisted_5, "STACKS : " + _toDisplayString(_ctx.getSelectedProject?.stack), 1)
    ], 2)
  ], 64))
}